// Malay language file
export const MS = {
  preparing_zip: "Menyediakan zip…",
  compressing: "Memampatkan…",
  info_icon: "Setelah ditandai sebagai selesai, tiada ahli tambahan boleh menyertai atau ditambah, dan semua kumpulan sembang akan dinyahaktifkan. Sila ambil perhatian bahawa projek, bersama dengan semua kumpulan sembang dan data, akan kekal boleh diakses dalam keadaan tidak aktif.",
  mark_is_done: "Adakah anda pasti mahu menandai projek sebagai selesai? Setelah ditandai, tiada ahli tambahan boleh menyertai atau ditambah, dan semua kumpulan sembang akan dinyahaktifkan. Sila ambil perhatian bahawa projek, bersama dengan semua kumpulan sembang dan data, akan kekal boleh diakses dalam keadaan tidak aktif.",
  mark_not_done: "Adakah anda pasti mahu membuka semula projek? Setelah ditandai sebagai terbuka, ahli tambahan boleh menyertai atau ditambah, dan semua kumpulan sembang akan diaktifkan semula.",
  mark_as_completed: "Tandai projek sebagai selesai",
  room_completed: "Projek selesai",
  room_members: "Ahli projek",
  deactivated_rooms: "Projek yang dinyahaktifkan",
  deactivated_chats: "Sembang yang dinyahaktifkan",
  completed_rooms: "Projek yang selesai",
  request_to_join_a_room: 'Permintaan untuk menyertai projek',
  wants_to_rejoin_room: 'Username ingin menyertai semula projek Roomname.',
  invited_you_to_join_room: 'Username menjemput anda untuk menyertai projek Roomname.',
  restart: "Mulakan semula",
  update_text: "Kemas kini baru tersedia. Klik mulakan semula untuk memasang kemas kini.",
  update_availble: "Kemas kini tersedia",
  Loading: "Memuatkan...",
  logout: "Log keluar",
  back: 'Kembali',
  company_list: "Senarai Syarikat",
  followers: "Pengikut",
  followings: "Mengikuti",
  article: "Artikel",
  companies: "Syarikat",
  one_to_one_chat: " Sembang satu lawan satu",
  profile: "Profil",
  company: "Syarikat",
  company_selection: "Pemilihan syarikat",
  home: "Laman Utama",
  contact: "Hubungi ",
  add_company: "Tambah Syarikat ",
  add_project: "Tambah Projek ",
  capacities: "Kapasiti ",
  work_area: "Kawasan Kerja",
  company_services: "Perkhidmatan syarikat",
  website: "Laman web",
  search_contacts: "Cari kenalan",
  add_or_join_a_company: "Tambah atau sertai syarikat",
  follow: "Ikuti",
  following: "Mengikuti",
  like: "Suka",
  company_contacts: "Kenalan syarikat",
  leave_the_company: "Tinggalkan syarikat",
  news: "Berita",
  earlier: "Sebelumnya",
  action: "Tindakan",
  another_action: "Tindakan lain",
  something_else: "Lain-lain",
  search: "Cari",
  search_rooms: "Cari projek",
  search_articles: "Cari artikel",
  contacts: "Kenalan",
  suggestions: "Cadangan",
  project_list: "Senarai projek",
  search_results: "Hasil carian",
  add_or_join_project: "Tambah atau sertai projek",
  details: "Butiran",
  your_position_within_company: "Sila pilih kedudukan anda dalam syarikat.",
  close_modal: "Tutup",
  map: "Peta",
  or: "Atau",
  name: "Nama*",
  street: "Jalan*",
  house_number: "Nombor Rumah",
  postal_code: "Poskod",
  city: "Bandar*",
  opened_by: "Dibuka oleh:",
  project_No: "Nombor projek: ",
  building_type: "Jenis Bangunan*",
  building_types: "Jenis Bangunan",
  add_join: "Tambah/Sertai",
  mandatory_fiels: "*medan wajib",
  invalid_fiels: "Medan ini diperlukan",
  add_or_join_company: "Tambah atau sertai syarikat",
  name_of_the_company: "Nama syarikat",
  edit_company_details: "Edit butiran syarikat",
  branch_of_the_building_industry: "Cabang industri pembinaan",
  corporate_form: "Bentuk korporat",
  position_within_company: "Kedudukan dalam syarikat",
  request_confirmation: "Permintaan projek tertunda",
  company_e_mail: "E-mel syarikat",
  type_of_filter: "Taip untuk menapis...",
  setting: "Tetapan",
  dashboard: "Papan pemuka",
  settings: "Tetapan",
  views: "Tontonan",
  times_seen: "kali dilihat",
  see_more: "...lebih banyak",
  see_less: "...kurang",
  in_search: "dalam carian",
  reset_password: "Set Semula Kata Laluan",
  submit: "Hantar",
  password: "Kata Laluan",
  email: "E-mel",
  confirm_password: "Sahkan Kata Laluan",
  reset_email: "Set Semula E-mel",
  update: "Kemas kini",
  new_email: "E-mel Baru",
  kjuup_message: "Mesej Kjuup",
  delete_profile: "Padam Profil?",
  my_position: "Kedudukan Saya:",
  add: "tambah",
  owner_company_admin: "Admin syarikat:",
  owner_company_admin_new: "Admin syarikat",
  mutual_contact: "kenalan bersama",
  mutual_contacts: "kenalan bersama",
  co_owner: "Pemilik bersama",
  managing_director: "Pengarah Urusan",
  associate: "Rakan kongsi",
  secretary: "Setiausaha",
  employee: "Pekerja",
  project_manage: "Pengurus Projek",
  auto_chat_translation: "Terjemahan Sembang Automatik",
  translate_room_group_names: "Terjemah nama kumpulan sembang",
  translate_room_group_names_info: "Apabila diaktifkan, nama kumpulan sembang diterjemahkan secara automatik ke bahasa antara muka.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Apabila diaktifkan, tab E-Mel akan dibuka secara lalai dan bukannya Mesej apabila membuka aplikasi.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Bahasa",
  english: "Bahasa Inggeris",
  german: "Bahasa Jerman",
  french: "Bahasa Perancis",
  italian: "Bahasa Itali",
  change_language: "Tukar Bahasa",
  my_companies: "Syarikat Saya",
  employees: "Pekerja",
  invite_with_a: "Jemput ke Kjuup",
  add_member: "Tambah Ahli",
  add_user: "Tambah Pengguna",
  send_location: "Hantar Lokasi",
  assign_admin_rights: "Laraskan hak admin",
  deactivate_company: "Nyahaktifkan Syarikat",
  remove_employees: "Buang Pekerja",
  remove_members: "Buang ahli",
  no_user_found: "Pengguna tidak dijumpai!",
  approve: "Luluskan!",
  deselect_all: "Nyahpilih Semua",
  select_all: "Pilih Semua",
  translation_on_building_projects: "Terjemahan di projek",
  reported_capacities: "Perkhidmatan yang dilaporkan",
  up_to_50m_exact: "Sehingga 50m Tepat",
  company_details_service: "Perkhidmatan Syarikat",
  company_contact: "Kenalan Syarikat",
  invite_with_link: "Jemput ke Kjuup",
  share_link: "Kongsi Pautan",
  share_company_link: "Kongsi pautan",
  qr_code: "Kod QR",
  copy_link: "Salin Pautan",
  cancel_link: "Batal Pautan",
  who_has_confirmed_services: "Siapa yang telah mengesahkan perkhidmatan anda?",
  projectss: "Projek",
  add_services: "Tambah Perkhidmatan",
  services: "Perkhidmatan",
  save_text: "Simpan",
  share_on: "Kongsi Di:",
  articlen: "Artikel",
  invite_user_to_confirm_service: "Jemput pengguna untuk mengesahkan perkhidmatan kepada syarikat.",
  link_copied: "Pautan Disalin!",
  email_copied: "E-mel Disalin!",
  personal_article: "Artikel Peribadi",
  company_article: "Artikel Syarikat",
  characters_remaining: "Aksara yang Tinggal",
  optional_information: "Maklumat Pilihan",
  project: "Projek",
  projects: "Projek...",
  abort: "Buang",
  preview: "Pratonton",
  post: "Hantar",
  of: "daripada",
  remove: "Buang",
  free_capacity: "Portal pekerjaan",
  current_status_overview: "Gambaran Keseluruhan Status Semasa",
  report_capacities: "Laporkan perkhidmatan",
  report_text: "Laporan",
  search_capacities: "Cari kontraktor",
  add_project_user: "Tambah Pengguna Projek",
  media: "Media",
  links: "Pautan",
  docs: "Dokumen",
  featured_products: "Produk Pilihan...",
  title: "Tajuk",
  text: "Teks",
  feed_details: "Butiran Suapan",
  add_employee: "Tambah Pekerja",
  latest: "Terkini",
  my_projects: "Projek Saya",
  cancel: "Batal",
  continue: "Teruskan",
  role_in_the_building_industry: "Peranan dalam Industri Pembinaan",
  als: "sebagai",
  join: "sertai",
  find: "Cari",
  request_to_join_a_company: "Permintaan untuk menyertai syarikat",
  wants_to_join_the_company: "mahu menyertai syarikat",
  filter_by: "Tapis mengikut",
  ok: "Ok",
  close: "Tutup",
  weekly_statistics: "Statistik Mingguan",
  is_following_you: "sedang mengikuti anda.",
  as: "sebagai",
  has_joined_the: "telah menyertai syarikat",
  has_looked_at_your_profile: "telah melihat profil anda.",
  time: "Masa",
  in_searches_in_past_week: "dalam carian minggu lepas.",
  has_liked_your_article: "telah menyukai artikel anda.",
  has_published_a_new_article: "telah menerbitkan artikel baru.",
  you: "Anda",
  all_views: "Semua Tontonan",
  all_profile_views: "Semua Tontonan Profil",
  mutual_company: "syarikat bersama",
  artical_text: "Tulis artikel...",
  you_have_appeared: "Anda telah muncul",
  your_request_at_the_company: "Permintaan anda di syarikat",
  times_you_have_appeared_in_searches: "kali anda telah muncul dalam carian",
  appear_more_often_in_searches: "Muncul lebih kerap dalam carian",
  you_have_been_found: "Anda telah dijumpai",
  improve_profile: "Tingkatkan Profil",
  choose_existing_contact_for_single_chat: "Pilih kenalan sedia ada untuk sembang tunggal:",
  in_order_to_add_new_contacts: "Untuk menambah kenalan baru, sila cari kenalan baru di halaman profil.",
  times_in_searches_in_the_last_week: "kali dalam carian minggu lepas. Kemas kini profil anda dan tambah butiran lanjut untuk lebih mudah dijumpai.",
  has_been_confirmed: "telah disahkan.",
  have_joined_the: "telah menyertai ",
  building_project: " projek pembinaan.",
  select_with_which_company_you_want_to_connect_to_the_project: "Pilih syarikat yang akan anda wakili. Ini akan dipaparkan kepada peserta lain.",
  select_with_which_company_you_want_to_connect_to_the_chat: "Pilih syarikat yang akan anda wakili. Ini akan dipaparkan kepada peserta lain.",
  select_internal_section: "Sila pilih bahagian dalaman",
  select_profile_image: "Pilih Imej Profil",
  share_user: "Kongsi Pengguna",
  contact_sender_message: "Kongsi pautan ini untuk menjemput bukan ahli Kjuup ke Kjuup. Pautan ini boleh digunakan oleh beberapa orang untuk mendaftar.",
  project_sender_message: "Kongsi pautan ini untuk menjemput bukan ahli Kjuup ke nama projek. Pautan ini boleh digunakan oleh beberapa orang untuk mendaftar dan menyertai nama projek di Kjuup.",
  company_sender_message: "Kongsi pautan ini untuk menjemput bukan ahli Kjuup ke syarikat nama syarikat. Pautan ini boleh digunakan oleh beberapa orang untuk mendaftar dan menyertai syarikat di Kjuup.",
  contact_receivers_message: "Pautan jemputan untuk menyertai Kjuup. Sila klik pautan untuk mendaftar kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message: "Sekiranya anda memasang Kjuup melalui Apple App Store, anda mesti klik pautan ini selepas muat turun berjaya, untuk dapat mendaftar.",
  project_receivers_message: "Pautan jemputan untuk menyertai nama projek di Kjuup. Sila klik pautan untuk mendaftar Kjuup dan menyertai nama projek.",
  company_receivers_message: "Pautan jemputan ke syarikat nama syarikat di Kjuup. Sila klik pautan untuk mendaftar Kjuup dan menyertai syarikat nama syarikat.",
  sign_in: "Log masuk",
  enter_your_email_add: "Masukkan alamat e-mel anda",
  forgot_password: "Lupa Kata Laluan",
  dont_have_account: "Tidak mempunyai akaun?",
  register: "Daftar",
  get_app: "Dapatkan aplikasi",
  registration: "Pendaftaran",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "Prof.",
  first_name: "Nama pertama",
  last_name: "Nama akhir",
  have_an_account: "Mempunyai akaun?",
  when_register_you_agree: "Apabila mendaftar, anda bersetuju dengan",
  term_of_use: "terma penggunaan",
  to: "kami.",
  in_our: "Dalam",
  data_policy: "dasar data",
  they_find_out: "mereka mengetahui,",
  we_provide_store_data: "cara kami mengumpul, memproses dan menyimpan maklumat.",
  leaving_company_text: "Adakah anda benar-benar mahu meninggalkan syarikat? Apabila meninggalkan syarikat, anda juga meninggalkan semua projek dan kumpulan sembang yang berkaitan. Anda boleh menyertai semula projek ini dengan syarikat lain pada bila-bila masa.",
  delete_profile_text: "Adakah anda benar-benar mahu memadam profil anda? Apabila anda memadam profil, semua sambungan ke syarikat, projek dan sembang akan dibuang. Anda boleh membuat profil baru pada bila-bila masa.",
  confirm: "Sahkan",
  reject: "Tolak",
  requet_to_leave: "Permintaan untuk pergi",
  choose: "Pilih",
  your_add_member: "Tambah ahli",
  if_you: "sekiranya anda",
  can_not_find: "tidak dapat mencari kenalan anda di sini.",
  please_wait: "Sila tunggu..",
  imprint_gtc: "Cap/Syarat & Terma",
  register_confirm_popup: "Sila sahkan e-mel Kjuup anda sebelum log masuk. Kami telah menghantar pautan pengesahan. Jika tidak kelihatan, semak juga folder spam.",
  PENDING_GROUP_USER: "akan menerima mesej hanya selepas jemputan ke projek disahkan. Mesej tambahan akan muncul sebaik sahaja jemputan ke projek disahkan.",
  PENDING: "Pengesahan jemputan ke projek tertunda",
  denied_group_chat: " telah menolak jemputan projek dan telah meninggalkan kumpulan ini.",
  joined_group_chat: " telah menyertai kumpulan ini",
  you_joined_group_chat: "Anda telah menyertai kumpulan ini.",
  Others: "Lain-lain",
  LEFT_GROUP: "telah meninggalkan kumpulan sembang ini.",
  YOU_LEFT_GROUP: "telah meninggalkan kumpulan sembang ini.",
  days: "hari",
  day: "hari",
  hour: "jam",
  hide_project: "Sembunyikan projek",
  hide_project_popup_text: "Jika anda menyembunyikan projek, mereka tidak boleh dijumpai dalam Kjuup. Hanya ahli projek yang boleh menjemput pengguna baru ke projek.",
  branch: "Cawangan",
  photo_video_media_lib: "Perpustakaan media - Foto dan Video",
  document: "Dokumen",
  location_meeting: "Lokasi / Mesyuarat",
  all_member_of_project: "Semua ahli projek",
  pending_request: "Permintaan projek tertunda",
  no_pending_request: "Tiada permintaan tertunda dijumpai!",
  news_feed: "Suapan Berita",
  user_info: "Maklumat Kumpulan",
  leave_project: "Tinggalkan projek",
  media_link_docs: "Fail",
  search_chat: "Cari Sembang",
  export_chat_group: "Eksport data kumpulan sembang dari bulan lepas",
  request_complete_chat_history: "Minta sejarah sembang lengkap",
  leave_chat_group: "Tinggalkan kumpulan sembang",
  add_user_project: "Tambah Pengguna",
  me: "Saya",
  max_open_one_to_one: "Pada masa ini maks. 2 sembang satu lawan satu boleh dibuka secara selari di bahagian bawah dan atas. Secara keseluruhan maks. 4 sembang satu lawan satu adalah mungkin.",
  are_you_sure_you_want_leave_chat: "Adakah anda pasti mahu meninggalkan kumpulan sembang ini?",
  create_group: "Buat Kumpulan",
  adding_members: "Menambah ahli...",
  creating_the_chat: "Mencipta sembang...",
  finishing_setup: "Menyiapkan...",
  group_name: "Nama Kumpulan",
  by: "Oleh:",
  mandetory: "*wajib",
  delteed: "telah memadam profilnya dan telah meninggalkan sembang kumpulan.",
  deleted_direct: "telah memadam profilnya dan telah meninggalkan sembang.",
  unhidden_message: "Jika anda membatalkan penyembunyian projek, mereka boleh dijumpai oleh semua ahli Kjuup.",
  account_deleted: "Akaun telah dipadam.",
  refuse_company: "Adakah anda pasti mahu menolak jemputan syarikat?",
  follow_additional: "Ikuti pengguna tambahan",
  f_add: "Ikuti pengguna tambahan Kjuup untuk menjadikan mereka tersedia untuk mesej langsung.",
  c_inv: "Jemputan syarikat",
  invited_o_Company: "Anda telah dijemput untuk menyertai syarikat",
  refuse_companyX: "Adakah anda pasti mahu menolak permintaan syarikat?",
  a_Da: "Akaun dinyahaktifkan.",
  has_deactivated: "telah menyahaktifkan profilnya.",
  reactive: "telah mengaktifkan semula profilnya.",
  juup_note: "*Pendaftaran dengan nama pengguna hanya tersedia untuk ahli Kjuup+",
  username: "Nama Pengguna*",
  email_username: "E-mel/Nama Pengguna*",
  sPinText: "Sila berikan PIN keselamatan 6 digit. PIN ini akan diperlukan sekiranya anda lupa kata laluan dan wajib untuk mengesahkan akaun anda.",
  DeleteKjuupPlusText: "Adakah anda benar-benar mahu memadam profil anda? Apabila anda memadam profil, semua sambungan ke syarikat, projek dan sembang akan dibuang.\n\nDalam 48 jam selepas pemadaman akaun, anda boleh mengaktifkan semula akaun anda dengan log masuk menggunakan nama pengguna, kata laluan dan PIN.",
  reactive_text: "Akaun anda telah dipadam. Sila klik Aktifkan Semula untuk mengaktifkan semula akaun anda.",
  rac: "Aktifkan Semula",
  ac_ss: "Akaun berjaya diaktifkan semula.",
  not_valid_pin: "PIN tidak sah",
  only_for_kjuup: "*Set semula kata laluan melalui nama pengguna dan PIN hanya tersedia untuk ahli Kjuup+.",
  resetPIN: "Set Semula PIN",
  enter_current_pin: "Sila masukkan PIN semasa anda",
  enter_new: "Masukkan PIN baru",
  pin_to_confirm: "Sila berikan PIN untuk pengesahan.",
  change_username: "Set Semula Nama Pengguna",
  pp_not_match: "Kata Laluan - dan Sahkan Kata Laluan tidak sepadan",
  reactive_itself: "Anda telah mengaktifkan semula profil anda.",
  has_deactivated_itself: "Anda telah menyahaktifkan profil anda.",
  more_than_two: "Pada masa ini mesej langsung hanya boleh dilakukan dengan 2 pengguna secara selari.",
  Chats: "Mesej Langsung",
  only_in_mobileL: "Video asli pada masa ini hanya boleh dimuat naik dan dihantar melalui Aplikasi mudah alih. Sila gunakan pautan video Youtube dan Vimeo.",
  register_pin_text: "Sila pilih PIN peribadi 6 digit anda. PIN ini akan diperlukan untuk membolehkan fungsi set semula akaun.",
  internal_project: "Dalaman",
  external_projects: "Luar",
  in_deacticted: "Bahagian dalaman dinyahaktifkan.",
  create_article: "Buat Artikel",
  new_article_selection: "Buat artikel untuk Suapan Berita luaran",
  new_article_selection_internal: "Buat artikel dalaman",
  active_trans_title: "Hidupkan terjemahan automatik?",
  active_trans: "Apabila dihidupkan, semua mesej sembang masuk akan diterjemahkan ke bahasa aplikasi yang anda pilih.",
  disable_trans: "Adakah anda benar-benar mahu menyahaktifkan terjemahan automatik?",
  allow_access_chat: "Tunjukkan sejarah sembang penuh",
  toggle_chat_history_on: "Adakah anda benar-benar mahu pengguna melihat sejarah sembang penuh?",
  toggle_chat_history_off: "Adakah anda benar-benar mahu pengguna hanya melihat sejarah sembang dari titik menyertai sembang?",
  check_selected_settings: "Sila semak tetapan sejarah sembang untuk semua pengguna yang dipilih!",
  chat_from_start_have: "Anda telah menyertai kumpulan ini. Sejarah sembang telah dikongsi.",
  chat_from_start_has: "telah menyertai kumpulan ini. Sejarah sembang telah dikongsi.",
  Address: "Alamat",
  read_by: "Dibaca oleh",
  deliver_to: "Dihantar ke",
  remaining: "tinggal",
  message_info: "Maklumat Mesej",
  request_to_join_only: "Permintaan untuk menyertai",
  unfollow: "Berhenti Mengikuti",
  company_username: "Nama Pengguna",
  month: ["Jan", "Feb", "Mac", "Apr", "Mei", "Jun", "Jul", "Ogo", "Sep", "Okt", "Nov", "Dis"],
  remove_my_admin_right: "Buang hak admin saya",
  makeEmp: "Adakah anda benar-benar mahu membuang hak admin syarikat daripada pengguna?",
  remove_my_self: "Adakah anda benar-benar mahu membuang hak admin syarikat daripada akaun anda?",
  makeAdmin: "Adakah anda benar-benar mahu memberikan hak admin syarikat kepada pengguna?",
  remove_member: "Buang Ahli",
  remove_following_confirm: "Adakah anda benar-benar mahu membuang {name} daripada senarai ikuti?",
  remove_follower_confirm: "Adakah anda benar-benar mahu membuang {name} daripada pengikut anda? Jika dibuang, dia tidak akan dimaklumkan.",
  do_you_really_want_to_remove: "Adakah anda benar-benar mahu membuang nama pengguna daripada syarikat?",
  invite_all: "Jemput semua ahli syarikat",
  invite_all_members: "Jemput semua ahli",
  mems: "Semua ahli lain",
  dep_loc: "Jabatan/Lokasi/Pasukan",
  depAdmin: "Admin Jabatan",
  add_remove_admin: "Tambah/Buang jawatan admin syarikat",
  add_remove_dep_admin: "Tambah/Buang jawatan admin jabatan",
  remove_employees_dept: "Buang Pekerja Dari",
  want_to_join_dep: "Nama pengguna mahu menyertai Jabatan/Lokasi/Pasukan depname syarikat companyname.",
  you_invited: "Anda telah dijemput untuk menyertai Jabatan/Lokasi/Pasukan depname syarikat companyname.",
  dep_remove: "Adakah anda benar-benar mahu membuang hak admin untuk jabatan atau lokasi daripada pengguna?",
  add_dep: "Adakah anda benar-benar mahu memberikan hak admin untuk jabatan atau lokasi kepada pengguna?",
  my_self_dep_remove: "Adakah anda benar-benar mahu membuang hak admin jabatan daripada akaun anda?",
  member: "Ahli",
  admin: "Admin",
  remove_project_admin: "Adakah anda benar-benar mahu membuang ahli daripada projek?",
  remove_my_self_project: "Adakah anda benar-benar mahu membuang hak admin?",
  remove_member_admin_right: "Adakah anda benar-benar mahu membuang hak admin daripada pengguna?",
  add_member_admin_right: "Adakah anda benar-benar mahu menambah hak admin kepada pengguna?",
  add_remove_Poss: "Tambah/Buang jawatan admin",
  forward: "Teruskan",
  edit: "Edit",
  only_kjuup_plus_can: "Hanya syarikat Kjuup+ boleh menghantar artikel.",
  add_images: "Tambah imej",
  request_confirmation: 'Jemputan projek tertunda',
  Activity: "Aktiviti",
  latest_messages: "Mesej terkini",
  hours: "jam",
  minute: "minit",
  seconds: "saat",
  days: "hari",
  yesterday: "semalam",
  last_week: "minggu lepas",
  next_week: "minggu depan",
  Last_month: "bulan lepas",
  All: "Semua",
  register_plus: "Pendaftaran Plus",
  select_files: "Pilih fail",
  monthsFullName: ["Januari", "Februari", "Mac", "April", "Mei", "Jun", "Julai", "Ogos", "September", "Oktober", "November", "Disember"],
  company_deploc_receivers_message: "Pautan jemputan ke jabatan syarikat company name di Kjuup. Sila klik pautan untuk mendaftar Kjuup dan menyertai syarikat company name.",
  no_news: "Tiada berita tersedia",
  reminder: "Peringatan",
  np_reminder: "Tiada ToDo",
  move_to_reminder: "Pindah ke ToDo",
  remove_reminder: "Adakah anda benar-benar mahu membuang mesej ini daripada senarai ToDo anda?",
  remove_all_reminder: "Buang semua ToDo",
  remove_all_confirm: "Adakah anda benar-benar mahu membuang semua mesej daripada senarai ToDo anda?",
  remove_from_reminder: "Buang daripada Peringatan",
  prevent_email: "E-mel tidak boleh digunakan sebagai Nama Pengguna.",
  allow_noti: "Sila benarkan notifikasi.",
  join_cap: "Sertai",
  pass_minimum: "**Kata laluan memerlukan 12 aksara termasuk huruf kecil, huruf besar, nombor dan aksara khas.",
  pass_error: "Sila semak keperluan kata laluan",
  people_that_like_article: "Orang yang menyukai artikel.",
  people_who_like_article: "Orang yang menyukai artikel anda.",
  message_delete: "Mesej ini telah dipadam.",
  message_edited: "disunting",
  edit_message: "Sunting mesej",
  edit_window_expired: "Mesej hanya boleh disunting dalam masa 10 minit selepas dihantar.",
  message_edit_save: "Simpan",
  copy: "Salin",
  bookmark: "Tanda buku",
  add_reaction: "Tambah reaksi",
  delete_message: "Padam mesej",
  more_options: "Lagi pilihan",
  info: "Info",
  link_invite: "Jemput melalui pautan",
  ll_nkk: "Jemput ke Kjuup",
  selected: "Dipilih",
  is_active: "Aktif",
  inactive: "Tidak aktif",
  last_online: "terakhir dilihat {{when}}",
  remove_user_l: "Buang",
  link_expire: "Setiap Pautan yang dihasilkan akan sah selama 72 jam.",
  company_language: "Bahasa syarikat",
  company_language_info: "Pemilihan bahasa akan digunakan untuk semua pengesahan e-mel berkaitan syarikat.",
  s_image: "imej",
  m_image: "imej",
  removeMsg: "Ketuk untuk membuang",
  block: 'Sekat',
  unblock: 'Nyahsekat',
  blocks: 'Adakah anda pasti mahu menyekat pengguna ini?',
  unblocks: 'Adakah anda pasti mahu nyahsekat pengguna ini?',
  bolcked_click_un_block: 'Anda telah menyekat kenalan ini. Klik di sini untuk membuang sekatan.',
  you_have_unblocked: 'Anda telah nyahsekat kenalan ini.',
  you_have_blocked: 'Anda telah menyekat kenalan ini.',
  unblock_to_send: 'Nyahsekat pengguna untuk menghantar mesej.',
  pilot_text: "AI Khusus untuk topik pembinaan",
  startup_screen_label: "Skrin permulaan",
  startup_screen_info: "Pilih skrin yang dibuka semasa Kjuup dimulakan.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Mesej",
  startup_screen_saved: "Skrin permulaan dikemas kini",
email_on: "Notifikasi e-mel sembang",
  email_on_grp: "Notifikasi e-mel",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Aktifkan atau nyahaktifkan notifikasi e-mel untuk projek ini. Pilihan ini hanya tersedia apabila \"Notifikasi e-mel sembang\" diaktifkan melalui tetapan peribadi.",
  todo_notification_info: "Anda akan dimaklumkan setiap kali tugasan baharu diberikan kepada anda.",
  info_val: "Anda akan menerima e-mel jika mesej sembang baharu tidak dibaca dalam masa singkat. Anda boleh mematikannya untuk projek atau sembang tertentu dalam tetapannya atau dalam maklumat kumpulan sembang.",
  email_groups: "Aktifkan atau nyahaktifkan notifikasi e-mel untuk sembang ini. Pilihan ini hanya tersedia apabila \"Notifikasi e-mel sembang\" diaktifkan melalui tetapan peribadi dan projek.",
  add_update_email: "Tambah/Kemas Kini E-mel",
  text_to_verifiy: "Pilihan \"Notifikasi e-mel sembang\" hanya boleh diaktifkan jika anda mempunyai alamat e-mel yang disahkan dalam fail.",
  stored_email: "E-mel tersimpan: ",
  verify_email: "Pengesahan tertunda!",
  join_call: "Sertai",
  call_is_started: "Panggilan dimulakan",
  start_chat: "Mulakan Sembang Langsung?",
  project_rooms: "Projek",
  download_selected: "Muat turun",
  add_employee_confirm: 'Adakah anda pasti mahu menambah pengguna ini ke syarikat?',
  invalid_deeplink: "URL deeplink tidak sah. Parameter yang diperlukan hilang.",
  deeplink_error: "Tidak dapat memproses deeplink. Sila cuba lagi kemudian.",
  reply: "Balas",
  reply_enter: "Masukkan balasan...",
  reply_sent_successfully: "Balasan berjaya dihantar",
  reply_failed: "Gagal menghantar balasan",
  reply_failed_generic: "Gagal menghantar balasan. Sila cuba lagi.",
  replying_to_message: "Membalas mesej",
  cancel_reply: "Batal balasan",
  voice_message: "Mesej suara",
  send: "Hantar",
  cancel: "Batal",
  type_your_reply: "Taip balasan anda...",
  suggested_replies: "Balasan yang Dicadangkan",
  suggestions_error: "Gagal memuatkan cadangan",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "Tunggu sebentar. Teks anda sedang disediakan secara individu untuk anda.",
  loading_chat_message: "Memuatkan sembang...",
  extracting_message: "Mengekstrak mesej...",
  create_todo: "Buat ToDo",
  create_todo_confirmation: "Adakah anda mahu membuat ToDo daripada mesej ini?",
  select_project_required: "Sila pilih projek/kumpulan",
  only_assigned_can_change_status: "Hanya pengguna yang ditugaskan boleh menukar status",
  todo_summary: "Ringkasan",
  todo_summary_placeholder: "Masukkan ringkasan todo...",
  todo_date: "Tarikh",
  todo_time: "Masa",
  todo_date_hint: "Biarkan kosong untuk menggunakan tarikh/masa mesej asal",
  todo_created_success: "ToDo berjaya dibuat",
  todo_creation_failed: "Gagal membuat ToDo",
  create: "Buat",
  image: "imej",
  images: "imej",
  remove_all_images: "Buang semua imej",
  remove_image: "Buang imej",
  remove_document: "Buang dokumen",
  remove_recording: "Buang rakaman",
  play_recording: "Mainkan rakaman",
  upload_image: "Muat naik imej",
  upload_document: "Muat naik dokumen",
  record_audio: "Rakam audio",
  stop_recording: "Hentikan rakaman",
  stop_recording_text: "Hentikan rakaman",
  please_remove_current_attachment: "Sila buang lampiran semasa ke",
  please_upload_image_file: "Sila muat naik fail imej yang sah",
  please_upload_valid_document: "Sila muat naik fail dokumen yang sah",
  searching_messages: "Mencari mesej...",
  loading_more: "Memuatkan lebih banyak...",
  loading_more_users: "Memuatkan lebih banyak pengguna...",
  load_more_users: "Muatkan Lebih Banyak Pengguna",
  no_more_users_to_load: "Tiada lagi pengguna untuk dimuatkan",
  no_messages_found: "Tiada mesej dijumpai",
  try_different_keyword: "Cuba kata kunci yang berbeza atau semak ejaan anda.",
  search_messages: "Cari mesej, kumpulan sembang, projek dan pengguna...",
  todo: "ToDo",
  np_todo: "Tiada ToDo",
  move_to_todo: "Simpan sebagai ToDo",
  remove_todo: "Adakah anda benar-benar mahu membuang ToDo?",
  remove_all_todo: "Buang semua ToDo",
  remove_all_todo_confirm: "Adakah anda benar-benar mahu membuang semua ToDo?",
  add_to_todo: "Tambah ke ToDo",
  remove_from_todo: "Buang daripada ToDo",
  confirm: "Sahkan",
  ok: "Ok",
  read_more: "Baca lebih lanjut",
  show_less: "Tunjukkan kurang",
  show_more: "Tunjukkan lagi",
  audio: "Audio",
  video: "Video",
  notification_schedule: "Jadual notifikasi",
  notification_schedule_desc: "Anda hanya akan menerima notifikasi push dan e-mel pada jam yang anda pilih. Di luar waktu tersebut, notifikasi akan dijeda.",
  learn_more: "Ketahui lebih lanjut",
  allow_notifications: "Benarkan notifikasi:",
  every_day: "Setiap hari",
  weekdays: "Hari bekerja (Isnin hingga Jumaat)",
  custom: "Tersuai",
  monday: "Isnin",
  tuesday: "Selasa",
  wednesday: "Rabu",
  thursday: "Khamis",
  friday: "Jumaat",
  saturday: "Sabtu",
  sunday: "Ahad",
  to: "hingga",
  notification_settings: "Notifikasi",
  notification_settings_saved: "Tetapan notifikasi berjaya disimpan",
  notification_settings_error: "Gagal menyimpan tetapan notifikasi",
  unavailability_note: "Nota Ketidaktersediaan",
  unavailability_description: "Tetapkan nota di luar pejabat. Semasa aktif, nota ditunjukkan kepada orang lain dalam semua perbualan anda dan pemberitahuan dijeda.",
  unavailability_start_date: "Tarikh mula",
  unavailability_end_date: "Tarikh tamat",
  unavailability_message: "Mesej",
  unavailability_message_hint: "Gunakan {endDate} sebagai pemegang tempat untuk tarikh kembali anda.",
  unavailability_replacement: "Kenalan Pengganti",
  unavailability_replacement_placeholder: "Masukkan ID pengguna untuk permintaan segera",
  unavailability_replacement_current: "Pengganti semasa",
  unavailability_replacement_hint: "Jika ditetapkan, pautan untuk menghubungi orang ini bagi perkara segera akan ditunjukkan dalam nota ketidaktersediaan anda.",
  unavailability_replacement_none: "Tiada pengganti (pilihan)",
  unavailability_contact_urgent: "Untuk permintaan segera hubungi",
  unavailability_default_message: "Saya tidak berada di pejabat buat masa ini dan tidak mempunyai akses kepada Kjuup. Saya akan tersedia semula mulai {endDate} dan akan menghubungi anda ketika itu.",
  unavailability_save: "Simpan",
  unavailability_deactivate: "Nyahaktifkan",
  unavailability_active_until: "Aktif sehingga",
  unavailability_saved: "Nota ketidaktersediaan disimpan",
  unavailability_save_error: "Gagal menyimpan nota ketidaktersediaan",
  unavailability_deactivated: "Nota ketidaktersediaan dinyahaktifkan",
  unavailability_end_date_required: "Tarikh tamat diperlukan",
  start_time_before_end_time: "Masa mula mesti sebelum masa tamat",
  loading: "Memuatkan",
  disabled: "Dinyahaktifkan",
  enable: "Aktifkan",
  disable: "Nyahaktifkan",
  forwarded: "Diteruskan",
  message_forwarded: "Mesej diteruskan!",
  schedule_article_post: "Jadualkan hantaran artikel",
  date: "Tarikh",
  time: "Masa",
  scheduled_for_publication: "Dijadualkan untuk penerbitan",
  article_will_be_published_on: "Artikel akan diterbitkan pada:",
  reset_selection: "Set Semula Pilihan",
  continue: "Teruskan",
  cancel: "Batal",
  error_loading_members: "Ralat memuatkan ahli",
  please_fill_all_fields: "Sila isi semua medan",
  invalid_email: "Alamat e-mel tidak sah",
  member_added_successfully: "Ahli berjaya ditambah",
  error_onboarding_user: "Ralat menambah pengguna",
  error_creating_chat: "Ralat membuat sembang",
  error_creating_group: "Ralat membuat kumpulan",
  new_group: "Kumpulan Baru",
  please_select_or_enter_group_name: "Sila pilih kumpulan atau masukkan nama kumpulan",
  please_select_or_enter_room_name: "Sila pilih projek atau masukkan nama projek",
  error_creating_room: "Ralat membuat projek",
  error_opening_chat: "Ralat membuka sembang",
  privacy_modal_text: "Pilih \"Peribadi\" hanya jika sembang tidak mengandungi kandungan profesional yang relevan untuk pengurus projek.",
  not_private: "Tidak peribadi",
  private: "Peribadi",
  error_loading_groups: "Ralat memuatkan kumpulan",
  automatic_chat_export: "Eksport sembang automatik",
  automatic_chat_export_info: "Selepas pengaktifan, sejarah sembang akan secara automatik dihantar ke alamat e-mel yang ditentukan setiap bulan.",
  automatic_chat_export_no_email: "Untuk mengaktifkan eksport sembang automatik, anda perlu menambah alamat e-mel terlebih dahulu. Anda boleh menambah alamat e-mel anda dalam tetapan peribadi.",
  enter_email: "Masukkan E-mel",
  update: "Kemas kini",
  confirm: "Sahkan",
  export_to_email: "Eksport akan pergi ke E-mel berikut.",
  start_chat_button: "Mesej baru",
  matching_existing_chats: "Mencocokkan sembang sedia ada",
  subject: "Subjek",
  add_subject: "Tambah subjek",
  chat_subject: "Subjek Sembang:",
  set_project_room: "Tetapkan projek",
  matching_existing_project_rooms: "Mencocokkan projek sedia ada",
  name_project_room: "Nama projek",
  professional_or_private: "Profesional atau peribadi",
  professional: "Profesional",
  privacy_modal_text_updated: "Pilih \"Peribadi\" hanya jika sembang tidak mengandungi kandungan profesional yang relevan untuk pengurus projek. Sembang peribadi tidak kelihatan kepada pengurus projek.",
  create_internal_chat: "Sembang luaran - atau dalaman?",
  internal_chat_description: "Hanya pekerja syarikat anda yang boleh ditambah ke sembang dalaman.",
  yes: "Ya",
  no: "Tidak",
  chat_is_being_created: "Sembang sedang dibuat...",
  discard_article_confirm: "Adakah anda benar-benar mahu membuang perubahan pada artikel ini?",
  please_enter_article_title: "Sila masukkan tajuk artikel terlebih dahulu.",
  please_add_mandatory_fields: "Sila tambah semua medan wajib",
  product_label: "Produk:",
  no_companies_found: "Tiada syarikat dijumpai",
  visible_to_all_followers: "Kelihatan kepada semua ahli Kjuup",
  only_visible_to_employees: "Hanya kelihatan kepada pekerja",
  something_went_wrong: "Sesuatu telah berlaku, Sila cuba lagi",
  please_select_department: "Sila pilih jabatan/lokasi",
  schedule: "Jadualkan",
  please_select_future_date_time: "Sila pilih tarikh dan masa pada masa hadapan untuk menjadualkan artikel.",
  please_select_different_date_time: "Sila pilih tarikh atau masa yang berbeza untuk menjadualkan artikel.",
  please_select_later_time: "Sila pilih masa yang lebih lewat daripada masa semasa untuk hari ini.",
  unpin_article: "Nyahpin artikel",
  pin_article: "Pin artikel",
  and: "dan",
  others: "lain-lain",
  at: "di",
  mute: "Bisukan",
  unmute: "Nyahbisukan",
  chat_muted_successfully: "Sembang berjaya dibisukan",
  chat_unmuted_successfully: "Sembang berjaya dinyahbisukan",
  mute_chat_confirm: "Adakah anda benar-benar mahu membisukan sembang ini? Anda tidak akan lagi menerima notifikasi untuk mesej baru.",
  unmute_chat_confirm: "Adakah anda benar-benar mahu menyahbisukan sembang ini? Anda akan kembali menerima notifikasi untuk mesej baru.",
  please_select_group_to_forward: "Sila pilih kumpulan untuk meneruskan mesej",
  record_not_found: "Rekod tidak dijumpai!",
  please_select_position: "Sila pilih kedudukan",
  delete_article_confirm: "Adakah anda pasti mahu memadam artikel ini?",
  delete_company_service_confirm: "Adakah anda pasti mahu memadam perkhidmatan syarikat?",
  block_translation_confirm: "Adakah anda benar-benar mahu menyekat terjemahan automatik di projek untuk semua ahli syarikat",
  unblock_translation_confirm: "Adakah anda benar-benar mahu menyahsekat terjemahan automatik di projek untuk semua ahli syarikat",
  please_select_file: "Sila pilih fail untuk dimuat naik",
  role_in_building_industry: "Peranan dalam industri pembinaan*",
  invalid_email_address: "Alamat E-mel Tidak Sah",
  please_enter_password: "Sila masukkan kata laluan",
  password_change_email_sent: "E-mel telah dihantar ke e-mel Kjuup anda. Sila sahkan kata laluan baharu dengan mengklik pautan pengesahan dalam e-mel.",
  please_enter_username: "Sila masukkan nama pengguna",
  username_same_as_before: "Nama pengguna tidak boleh sama seperti sebelumnya",
  profile_deleted_successfully: "Profil Berjaya Dipadam",
  hardware_requirements: "Keperluan Perkakasan",
  hardware_requirements_list: "• 4GB RAM<br/>• Kelajuan CPU min. 2GHz<br/>• Windows 7 atau lebih tinggi / semua versi macOS",
  submitting: "Menghantar...",
  signing_in: "Log masuk...",
  please_enter_service_name: "Sila masukkan nama perkhidmatan",
  something_went_wrong_error: "Aduh! Sesuatu telah berlaku...",
  something_went_wrong_try_again: "Maaf, sesuatu telah berlaku di sana. Cubalah lagi",
  position_label: "Kedudukan:",
  loading_room: "Memuatkan projek...",
  navigating_to_room: "Navigasi ke projek",
  loading_chat: "Memuatkan sembang...",
  translate: "Terjemahkan",
  show_original: "Tunjukkan Asal",
  saving: "Menyimpan...",
  language_selection_info: "Pemilihan bahasa digunakan untuk semua pengesahan e-mel berkaitan syarikat.",
  nav_call: "Panggilan",
  nav_home: "Laman Utama",
  nav_messages: "Mesej",
  nav_todo: "tugasan",
  nav_rooms: "Projek",
  nav_all_rooms: "Semua projek",
  pinned_rooms_max: "Anda boleh pin sehingga 10 projek.",
  pinned_room_unpin: "Nyahpin",
  pinned_rooms_drop: "Seret projek anda ke sini untuk pilihan pantas",
  nav_profile: "Profil",
  nav_company: "Syarikat",
  nav_company_documents: "Dokumen",
  nav_logout: "Log keluar",
  add_member_title: "Tambah Ahli",
  continue_btn: "Teruskan",
  search_placeholder: "Cari",
  no_members_found: "Tiada ahli dijumpai",
  no_groups_found: "Tiada kumpulan dijumpai",
  no_rooms_found: "Tiada projek dijumpai",
  search_users_tab: "Pengguna",
  search_documents_tab: "Dokumen",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Tiada fail",
  no_documents_available: "No documents",
  searching_users: "Mencari pengguna...",
  no_users_found: "Tiada pengguna ditemui",
  search_emails_tab: "E-mel",
  searching_emails: "Mencari e-mel...",
  no_emails_found: "Tiada e-mel ditemui",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Kumpulan Tanpa Nama",
  unnamed_room: "Projek Tanpa Nama",
  all_members: "Semua",
  room_label: "Projek:",
  subject_label: "Subjek:",
  no_members: "Tiada ahli",
  creating_structure: "Membuat struktur anda",
  opening_chat: "Membuka sembang",
  please_wait: "Harap tunggu...",
  loading_todo: "Memuatkan ToDo...",
  task_updated: "Tugas dikemas kini",
  error_updating_task: "Ralat mengemas kini tugas",
  task_deleted: "Tugas dipadam",
  error_deleting_task: "Ralat memadam tugas",
  delete_task_confirm: "Adakah anda pasti mahu memadam tugas ini?",
  description_label: "Penerangan",
  description_placeholder: "Masukkan penerangan...",
  date_time_label: "Tarikh & Masa",
  save_hint: "Ctrl+Enter untuk menyimpan, Esc untuk membatalkan",
  edit_label: "Edit",
  delete_label: "Padam",
  todo_list_title: "tugasan",
  tasks_count: "tugas",
  search_placeholder_todo: "Cari...",
  select_task_to_open_chat: "Pilih tugas untuk membuka sembang",
  today: "Hari ini",
  yesterday: "Semalam",
  time_suffix: "",
  from_chat: "ToDo Sumber",
  assigned_to: "Ditugaskan kepada",
  assign_users: "Tetapkan pengguna",
  no_users_assigned: "Tiada pengguna ditugaskan",
  assign: "Tetapkan",
  assign_to: "Tetapkan kepada...",
  navigate_to_chat: "Navigasi ke Sembang",
  navigate_to_email: "Navigasi ke e-mel",
  show_original_message: "Tunjukkan sumber",
  hide_original_message: "Sembunyikan sumber",
  status_pending: "Tertunda",
  status_in_progress: "Sedang Berlangsung",
  status_completed: "Selesai",
  show: "Tunjukkan",
  close: "Tutup",
  // Log translations
  status_confirmed: "[Disahkan]",
  log_todo_created: "ToDo [dicipta]",
  log_todo_confirmed: "ToDo [disahkan]",
  log_todo_deleted: "ToDo [dipadam]",
  log_todo_updated: "ToDo [dikemas kini]",
  log_description_updated: "[Penerangan dikemas kini]",
  log_deadline_updated: "[Tarikh akhir dikemas kini]",
  log_assigned_to: "[Ditugaskan kepada] {name}",
  log_unassigned_from: "[Ditarik balik dari] {name}",
  log_assignment_added: "[Tugasan ditambah]: {name}",
  log_assignment_removed: "[Tugasan dibuang]: {name}",
  log_status_updated: "[Status diubah dari] {from} [ke] {to}",
  log_status_changed: "[Status diubah]",
  log_status_changed_to: "[Status diubah kepada] {status}",
  log_changed_status_to: "[Mengubah status kepada]:",
  log_for_user: "[untuk pengguna]:",
  log_user_updated_status: "[Pengguna mengemas kini status todo mereka]",
  log_changed_date_to: "[Mengubah tarikh kepada]:",
  log_changed_description_to: "[Mengubah penerangan kepada]:",
  log_moved_to: "[Dipindahkan ke] {status}",
  todo_status_updated_from: "[dari]",
  todo_status_updated_to: "[ke]",
  filter_pending: "Tertangguh",
  filter_confirmed: "Disahkan",
  filter_assigned_to_me: "Tugas saya",
  filter_assigned_by_me: "Diwakilkan",
  todo_project_label: "Projek:",
  assigned_users: "Pengguna yang ditugaskan:",
  todo_chat_label: "Sembang:",
  history: "Sejarah",
  todo_assigned_by: "Ditugaskan oleh:",
  todo_assigned_push: "ToDo ditugaskan:",
  todo_assigned_push_empty: "ToDo baharu telah ditugaskan kepada anda.",
  search_groups: "Kumpulan",
  search_chat_groups: "Kumpulan sembang",
  search_project_room: "Projek",
  search_messages_tab: "Mesej",
  searching_groups: "Mencari kumpulan...",
  searching_rooms: "Mencari projek...",
  no_groups_found: "Tiada kumpulan ditemui",
  no_rooms_found: "Tiada projek ditemui",
  create_poll: "Tinjauan pendapat",
  poll_question_label: "SOALAN",
  poll_question_placeholder: "Kemukakan soalan",
  poll_options_label: "PILIHAN",
  poll_option: "Pilihan",
  poll_add_option: "Tambah pilihan",
  poll_allow_multiple: "Benarkan berbilang jawapan",
  poll_multiple_allowed: "Pilih satu atau lebih pilihan",
  poll_select_option: "Pilih satu pilihan",
  poll_view_votes: "Lihat undian",
  poll_vote_singular: "undian",
  poll_vote_plural: "undian",
  poll_votes: "Keputusan tinjauan",
  poll_no_votes_yet: "Tiada undian lagi",
  transcript_step_processing: "Transkripsi sedang dijalankan...",
  ai_transcript_tab: "AI-Transkripsi",
  ai_transcript_info: "Hanya tersedia untuk mesej suara yang dicipta selepas 09.03.2026.",
  transcript_more: "...lagi",
  transcript_less: "...kurang",
  ki_transcript_voice_message: "KI-Transkripsi mesej suara",
  ki_image_analysis: "Analisis imej berkuasa AI",
  type_message: "Taip mesej",
  email_tab_messages: "Mesej",
  email_tab_email: "E-Mel",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Akaun E-mel",
  email_connect_gmail: "Sambung Gmail",
  email_connect_outlook: "Sambung Outlook",
  email_no_accounts: "Tiada akaun e-mel disambungkan",
  email_no_accounts_hint: "Sambungkan akaun e-mel dalam tetapan profil anda",
  email_no_messages: "Tiada e-mel",
  email_from: "Daripada",
  email_to: "Kepada",
  email_subject: "Subjek",
  email_disconnect: "Putuskan sambungan",
  email_disconnect_confirm: "Adakah anda pasti mahu memutuskan sambungan akaun e-mel ini? Semua e-mel yang disegerakkan akan dialih keluar.",
  email_account_disconnected: "Akaun e-mel berjaya diputuskan",
  email_account_disconnect_failed: "Gagal memutuskan akaun",
  email_connecting: "Menyambung...",
  email_account_connected: "Akaun berjaya disambungkan",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Pergi ke Tetapan",
  email_date: "Tarikh",
  email_reply: "Balas",
  email_forward: "Teruskan",
  email_copy_text: "Salin teks",
  email_text_copied: "Disalin!",
  email_text_copy_failed: "Teks tidak dapat disalin.",
  email_delete: "Padam",
  email_not_spam: "Bukan Spam",
  email_not_spam_success: "E-mel dipindahkan ke peti masuk.",
  email_not_spam_failed: "Gagal memindahkan ke peti masuk.",
  email_delete_confirm: "Adakah anda pasti mahu memadamkan e-mel ini?",
  email_delete_from_folder: "Adakah anda pasti mahu memadamkan daripada {folder}?",
  email_delete_permanent_from_folder:
    "Adakah anda pasti mahu memadamkan secara kekal daripada {folder}? Tindakan ini tidak boleh dibatalkan.",
  email_save_draft_confirm: "Adakah anda ingin menyimpan e-mel ini sebagai draf?",
  email_save_draft: "Simpan Draf",
  email_discard: "Buang",
  email_back_to_compose: "Kembali menulis",
  email_draft_saved: "Draf disimpan.",
  email_draft_save_failed: "Gagal menyimpan draf.",
  email_loading: "Memuatkan e-mel...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Pilih",
  email_attachment_singular: "Lampiran",
  email_attachment_plural: "Lampiran",
  email_back: "Kembali",
  email_download: "Muat turun",
  email_close: "Tutup",
  email_preview: "Pratonton",
  email_preview_not_available: "Pratonton tidak tersedia",
  email_preview_failed: "Pratonton tidak tersedia",
  select_attachments: "Pilih lampiran",
  email_loading_preview: "Memuatkan pratonton...",
  email_mark_unread_failed: "e-mel tidak dapat ditandakan sebagai belum dibaca.",
  email_delete_failed: "e-mel tidak dapat dipadamkan.",
  filter_all: "Semua",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Mesej Langsung",
  my_notes: "My Space",
  filter_internal_groups: "Sembang kumpulan dalaman",
  filter_external_groups: "Sembang kumpulan luaran",
  filter_group_chats: "Sembang kumpulan",
  filter_groups_internal: "Dalaman",
  filter_groups_external: "Luaran",
  filter_unread_only: "Hanya belum dibaca",
  room_daily_briefing_info: "Apabila diaktifkan, laporan untuk projek ini dijana setiap 24 jam pada masa yang ditetapkan dalam tetapan peribadi — tetapi hanya jika terdapat aktiviti dalam tempoh itu.",
  email_select_all: "Pilih semua",
  email_deselect_all: "Nyahpilih semua",
  email_reply_all: "Balas semua",
  email_reply_placeholder: "Taip balasan anda...",
  email_forward_placeholder: "Tambah mesej...",
  email_edit_draft: "Edit draf",
  email_attach: "Lampirkan",
  email_attachment_from_original: "Dari mesej asal",
  email_remove: "Buang",
  email_drop_files: "Lepaskan fail untuk dilampirkan",
  email_loading_attachments: "Memuatkan lampiran...",
  email_archive: "Arkib",
  mark_unread: "Tanda sebagai belum dibaca",
  mark_read: "Tanda sebagai sudah dibaca",
  email_all_accounts: "Semua akaun",
  email_error: "Ralat",
  email_delete_email_failed: "Gagal memadam e-mel.",
  enter_url: "Masukkan URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Langgan sekarang',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: 'CUBAAN PERCUBAAN PERCUMA 1 BULAN',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Tiada pembayaran hari ini. Butiran kad kredit tidak diminta sebelum langganan berbayar bermula.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Urus semua akaun e-mel terus dalam Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI menulis balasan – anda hanya mengesahkan',
  kjuup_io_feature_tasks: 'Tugas & kalendar sentiasa dikemas kini secara automatik',
  kjuup_io_choose_plan: 'Pilih pelan',
  kjuup_io_plan_monthly: 'Bulanan',
  kjuup_io_plan_yearly: 'Tahunan',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Dilindungi oleh Stripe · batalkan bila-bila masa',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Pembayaran diterima. Mengaktifkan langganan anda…',
  kjuup_io_toast_activating_soon: 'Pembayaran diterima. Langganan anda akan diaktifkan sebentar lagi.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} jam lagi',
  kjuup_io_trial_left_hour: '1 jam lagi',
  kjuup_io_trial_left_minutes: '{count} minit lagi',
  kjuup_io_trial_left_minute: '1 minit lagi',
  kjuup_io_trial_left_seconds: '{count} saat lagi',
  kjuup_io_trial_left_second: '1 saat lagi',
  kjuup_io_trial_ending_now: 'Tempoh percubaan anda sedang tamat…',
  kjuup_io_request_timeout: 'Sambungan tamat masa. Sila cuba lagi.',
  kjuup_io_info_days_free: '{days} hari sepenuhnya percuma – langganan anda bermula selepas percubaan.',
  kjuup_io_discount_total: 'Diskaun anda: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Peribadi: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Tutup',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Percubaan percuma anda telah tamat',
  kjuup_io_trial_ended_body: 'Langgan Kjuup.io untuk terus menggunakan e-mel dan ciri premium yang lain.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Percubaan percuma anda telah bermula',
  kjuup_io_toast_trial_fail: 'Tidak dapat memulakan percubaan percuma',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / bulan',
  kjuup_io_save_amount_year: 'Jimat {price} setahun',
  kjuup_io_billed_annually_amount: '{price} dibilkan setiap tahun',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Apa yang anda dapat:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Kad kredit tidak diperlukan – mula segera tanpa data pembayaran.',
  kjuup_io_info_cancel_anytime: 'Batalkan bila-bila masa – tiada komitmen, tiada risiko.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Tempoh pengebilan',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Kaedah pembayaran disimpan. Anda akan dicaj apabila tempoh percubaan tamat.',
  calendar_sync_info: 'Segerakkan secara automatik semua ToDo Kjuup dengan kalendar anda.',
  calendar_no_accounts: 'Tiada kalendar disambungkan lagi.',
  article_new_badge: 'BARU',
  article_new_posts: '{0} siaran baharu',
  documents: 'Dokumen',
  add_documents: 'Tambah dokumen',
  no_preview_available: 'Pratonton tidak tersedia',
  no_preview_hint: 'Jenis fail ini tidak boleh dipratonton, tetapi ia tetap akan dihantar.',
  max_documents_reached: 'Anda boleh melampirkan sehingga 10 dokumen pada satu masa.',
  open_file: 'Buka fail',
  twofa_title: 'Pengesahan dua faktor',
  twofa_method_totp: 'Apl pengesah',
  twofa_method_sms: 'Mesej teks',
  twofa_method_email: 'E-mel',
  twofa_enter_app: 'Masukkan kod 6 digit dari apl pengesah.',
  twofa_enter_sms: 'Masukkan kod 6 digit yang kami hantar melalui SMS.',
  twofa_enter_email: 'Masukkan kod 6 digit yang kami hantar ke e-mel.',
  twofa_resend: 'Hantar semula kod',
  twofa_try_another: 'Cuba kaedah lain',
  twofa_remember_device: 'Jangan tanya lagi pada peranti ini selama 30 hari',
  twofa_sent: 'Kami telah menghantar kod.',
  twofa_invalid_code: 'Kod itu tidak betul. Sila cuba lagi.',
  twofa_something_wrong: 'Sesuatu tidak kena. Sila cuba lagi.',
  twofa_method_unavailable: 'Kaedah itu tidak tersedia.',
  twofa_on_desc: 'Pengesahan dua faktor diaktifkan. Anda perlukan kod setiap kali log masuk.',
  twofa_off_desc: 'Tambah langkah kedua selepas kata laluan. Apl pengesah paling selamat.',
  twofa_methods: 'Kaedah',
  twofa_on: 'Hidup',
  twofa_add: 'Tambah',
  twofa_default_method: 'Kaedah lalai',
  twofa_default: 'Lalai',
  twofa_turn_off: 'Matikan',
  twofa_disable_hint: 'Masukkan kata laluan dan kod semasa untuk mematikan pengesahan dua faktor.',
  twofa_disable_need: 'Masukkan kata laluan dan kod pengesahan.',
  twofa_code_placeholder: 'Kod 6 digit atau kod sandaran',
  twofa_send_code: 'Hantar kod',
  twofa_primary_updated: 'Kaedah lalai dikemas kini.',
  twofa_disabled: 'Pengesahan dua faktor kini dimatikan.',
  twofa_enabled: 'Pengesahan dua faktor kini diaktifkan.',
  twofa_totp_help: 'Imbas kod QR ini dengan Google Authenticator, Authy atau 1Password. Anda juga boleh masukkan kunci secara manual.',
  twofa_secret_copied: 'Kunci disalin',
  twofa_sms_help: 'Masukkan nombor dalam format antarabangsa. Kami akan hantar kod 6 digit melalui SMS.',
  twofa_email_help: 'Kami akan hantar kod 6 digit ke e-mel akaun anda.',
  twofa_backup_title: 'Kod sandaran',
  twofa_backup_help: 'Simpan kod sekali guna ini di tempat selamat. Setiap kod boleh digunakan sekali jika telefon hilang.',
  twofa_copy_codes: 'Salin kod',
  twofa_codes_copied: 'Kod sandaran disalin',
  twofa_regenerate: 'Dapatkan kod sandaran baharu',
  twofa_regenerate_hint: 'Ini menggantikan kod sandaran yang belum digunakan. Masukkan kata laluan dan kod semasa.',
  twofa_backup_remaining: '{n} kod sandaran yang belum digunakan tinggal',
  twofa_new_codes: 'Kod sandaran baharu',
  twofa_sms_unavailable: 'Kod SMS belum tersedia.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Tugasan Kjuup yang diberikan kepada anda disalin ke projek Kjuup dalam Todoist anda. Perubahan dalam Todoist tidak disalin kembali.",
  todoist_connect: "Sambung Todoist",
  todoist_connected: "Todoist disambungkan",
  todoist_connect_failed: "Sambungan Todoist gagal",
  todoist_disconnect: "Putuskan",
  todoist_disconnected: "Todoist diputuskan",
  todoist_disconnect_confirm: "Putuskan Todoist? Tugasan yang sudah ada dalam Todoist kekal. Penyegerakan berhenti.",
  todoist_sync_now: "Segerak sekarang",
  todoist_syncing: "Menyegerak…",
  todoist_sync_done: "Penyegerakan selesai",
  todoist_sync_failed: "Penyegerakan gagal",
  todoist_auth_error: "Sambung semula Todoist untuk terus menyegerak.",
  todoist_last_sync: "Penyegerakan terakhir",
  todoist_not_connected: "Todoist tidak disambungkan",
  todoist_auth_url_failed: "Halaman kebenaran Todoist tidak dapat dibuka.",
  recommend_text: "Sertai Kjuup untuk kekal berhubung dan pastikan komunikasi kamu tersusun. Himpunkan saluran kamu, simpan mesej dalam projek yang betul dan mulakan setiap pagi dengan ringkasan serta tugasan kamu – semuanya diselaraskan dengan aplikasi yang kamu sudah guna. Mula secara percuma:",
  pro_auth_signin_title: 'Selamat kembali',
  pro_auth_signin_sub: 'Log masuk dengan e-mel kerja anda.',
  pro_auth_email_or_username: 'E-mel atau nama pengguna',
  pro_auth_email_placeholder: 'nama@syarikat.de',
  pro_auth_forgot_password: 'Lupa kata laluan?',
  pro_auth_create_account: 'Cipta akaun',
  pro_auth_show_password: 'Tunjukkan kata laluan',
  pro_auth_hide_password: 'Sembunyikan kata laluan',
  pro_auth_register_sub: 'Kami akan menghantar pautan untuk mengesahkan e-mel anda.',
  pro_auth_register_plus_sub: 'Pilih nama pengguna dan kata laluan. Seterusnya anda akan menetapkan PIN keselamatan anda.',
  pro_auth_check_credentials: 'Semak e-mel dan kata laluan anda',
  pro_news_export_pdf: 'Eksport sebagai PDF',
  pro_news_pdf_failed: 'PDF tidak dapat dicipta.',
  pro_news_pdf_attachments: 'Lampiran',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Masukkan e-mel anda dan kami akan menghantar pautan untuk menetapkan semula kata laluan anda.',
  pro_auth_send_link: 'Hantar pautan set semula',
  pro_auth_plus_reset: 'Set semula dengan PIN',
  pro_auth_show_pin: 'Tunjukkan PIN',
  pro_auth_hide_pin: 'Sembunyikan PIN',
  v2_auth_plus_only: 'Kjuup+ sahaja',
  room_action_media: "Fail",
  room_tab_overview: "Gambaran",
  room_tab_history: "Sejarah",
  chat_info_media: "Fail",
  messages: "mesej",
  pro_todo_project_required: "Sila pilih projek",
  pro_todo_choose_project: "Tugasan ini untuk projek mana?",
  cockpit_report_delete_confirm: "Padam laporan harian ini?",
  cockpit_report_deleted: "Laporan harian dipadam",
  cockpit_tab_company: "Syarikat",
  cockpit_bookmarked_priorities: "Tugasan yang ditanda",
  cockpit_load_error: "Cockpit tidak dapat dimuatkan.",
  cockpit_retry: "Cuba lagi",
  cockpit_yesterday: "Semalam",
  cockpit_greeting_morning: "Selamat pagi",
  cockpit_greeting_day: "Selamat tengah hari",
  cockpit_greeting_evening: "Selamat petang",
  cockpit_assistant_q_open: "Apa yang masih terbuka hari ini?",
  cockpit_assistant_q_summarize: "Ringkaskan sembang {{room}}",
  cockpit_assistant_q_overdue: "Tugasan mana yang lewat?",
  cockpit_assistant_new: "{{n}} baharu",
  cockpit_assistant_important: "{{n}} penting",
  cockpit_assistant_title: "Pembantu Kjuup",
  cockpit_assistant_hint: "Ketik dan tanya",
  room_overview_priority_no_detail: "Laporan tidak memberikan butiran lanjut tentang keutamaan ini.",
  room_overview_priority_from: "Sumber: {{name}}",
  room_overview_priority_open_task: "Buka tugasan",
  cockpit_priority_position: "{{index}} daripada {{total}} keutamaan",
  room_overview_today_title: "Penting hari ini",
  room_overview_all_tasks: "Semua",
  room_overview_tasks_empty: "Tiada tarikh akhir atau tugasan terbuka",
  room_overview_appointments_empty: "Tiada janji temu akan datang",
  room_overview_no_priorities: "Tiada keutamaan terbuka dalam laporan terkini.",
  cockpit_report_top5: "5 keutamaan teratas",
  cockpit_report_todo_created: "ToDo dicipta",
  cockpit_report_source_missing: "Mesej sumber tidak ditemui.",
  delete_bookmarked_priority_confirm: "Adakah anda pasti mahu memadam tugasan yang ditanda ini?",
  cockpit_report_create_todo: "Cipta ToDo",
  cockpit_priorities_deleting: "Memadam …",
  cockpit_priorities_select: "Padam beberapa",
  cockpit_report_none: "Tiada entri.",
  cockpit_priorities_delete_confirm: "Adakah anda pasti mahu memadam {count} tugasan yang ditanda?",
  cockpit_priorities_delete_failed: "{count} tugasan tidak dapat dipadam",
  cockpit_priorities_deleted: "{count} tugasan dipadam",
  cockpit_priorities_selected: "{count} dipilih",
  cockpit_channel_connected: "Disambungkan",
  cockpit_channel_not_connected: "Tidak disambungkan",
  cockpit_channel_connect: "Sambung",
  cockpit_channel_chat: "Sembang Kjuup",
  cockpit_channel_active: "Aktif",
  cockpit_channel_hidden: "Disembunyikan",
  cockpit_channel_enable: "Dayakan",
  cockpit_channel_email: "E-mel",
  cockpit_channel_check: "Semak sambungan",
  cockpit_channel_fix: "Semak",
  cockpit_channel_forward: "Alamat pemajuan",
  cockpit_channel_not_set_up: "Belum disediakan",
  cockpit_channel_set_up: "Sediakan",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Sambungan terputus",
  cockpit_channel_importing: "Mengimport",
  cockpit_channel_removing: "Memutuskan sambungan",
  cockpit_channel_reconnect: "Sambung semula",
  cockpit_channels_title: "Saluran",
  cockpit_company_role_super_admin: "Pentadbir syarikat",
  cockpit_company_role_dept_admin: "Pentadbir jabatan",
  cockpit_company_role_member: "Pekerja",
  cockpit_company_none: "Syarikat Kjuup+ tidak ditemui",
  cockpit_company_eyebrow: "Syarikat",
  cockpit_company_inactive: "tidak aktif",
  cockpit_company_settings: "Tetapan syarikat",
  cockpit_company_employees: "Pekerja",
  cockpit_company_internal_rooms: "Projek dalaman",
  cockpit_report_all_projects: "Semua projek",
  cockpit_report_progress_emails: "Menganalisis e-mel",
  cockpit_report_progress_chats: "Menganalisis mesej sembang",
  cockpit_report_progress_documents: "Menganalisis lampiran dan dokumen",
  cockpit_report_progress_tasks: "Menganalisis tugasan",
  cockpit_report_progress_summarizing: "Menganalisis kandungan",
  cockpit_report_progress_reading: "Menggunakan semula kandungan yang telah dianalisis",
  cockpit_report_progress_collecting: "Mengumpul e-mel, sembang dan tugasan daripada projek anda",
  cockpit_report_progress_priorities: "Menyusun keutamaan, tarikh akhir dan keputusan",
  cockpit_report_progress_queued: "Menyediakan laporan",
  cockpit_report_creating_title: "Laporan harian anda sedang disediakan",
  cockpit_report_progress_count_one: "1 item dianalisis",
  cockpit_report_progress_count_many: "{{count}} item dianalisis",
  cockpit_report_progress_hint: "Ini biasanya mengambil satu hingga dua minit – anda boleh terus menggunakan cockpit sementara itu.",
  cockpit_report_time_hint: "Laporan harian dicipta setiap hari pada pukul {{hour}}:00 untuk lima projek paling aktif.",
  room_overview_priorities_title: "Status dan keutamaan semasa",
  room_overview_as_of: "Setakat {{time}}",
  cockpit_report_delete: "Padam laporan harian",
  email_tag_daily_briefing: "Laporan harian",
  cockpit_report_unread: "Baharu",
  cockpit_report_clear_project: "Papar semua projek",
  cockpit_filter_project: "Projek",
  cockpit_filter_all_projects: "Semua projek",
  cockpit_report_recreate: "Cipta semula laporan harian",
  cockpit_report_hide_previous: "Sembunyikan laporan harian terdahulu",
  cockpit_report_show_previous: "Papar laporan harian terdahulu",
  cockpit_report_room_empty: "Belum ada laporan harian untuk projek ini",
  cockpit_report_empty: "Belum ada laporan harian",
  cockpit_report_room_empty_hint: "Cipta laporan harian untuk projek ini sahaja.",
  cockpit_report_needs_mailbox: "Sambungkan akaun e-mel supaya Kjuup boleh mencipta laporan harian dengan tugasan automatik.",
  cockpit_report_create: "Cipta laporan harian",
  cockpit_email_connect: "Sambung e-mel",
  cockpit_email_none_title: "Belum ada akaun e-mel disambungkan",
  cockpit_email_none_reports: "Sambungkan peti mel anda supaya Kjuup boleh menetapkan e-mel masuk kepada projek anda dan mencipta laporan harian dengan tugasan.",
  cockpit_email_none_client: "Sambungkan Gmail, Outlook atau IMAP untuk membaca, menetapkan dan membalas e-mel terus dalam Kjuup.io.",
  cockpit_email_reports_title: "Klien e-mel semasa",
  cockpit_email_reports_text: "Tiada peti masuk dalam Kjuup.io · {{rooms}} projek dengan laporan harian pada pukul {{hour}}:00 · e-mel masuk ditetapkan kepada projek anda.",
  cockpit_email_reports_rooms: "Urus projek",
  cockpit_email_settings: "Tetapan e-mel",
  cockpit_email_error_title: "Semak sambungan",
  cockpit_email_client_title: "Peti masuk disambungkan",
  cockpit_email_accounts_n: "{{n}} akaun disambungkan",
  cockpit_email_last_sync: "segerak terakhir {{when}}",
  cockpit_email_report_at: "Laporan harian pada pukul {{hour}}:00",
  cockpit_email_open_inbox: "Buka peti masuk",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Alamat e-mel yang disambungkan",
  email_folder_sent: "Item Dihantar",
  email_no_subject: "(Tiada subjek)",
  cockpit_email_detail_loading: "Memuatkan e-mel …",
  cockpit_email_detail_failed: "E-mel tidak dapat dimuatkan.",
  cockpit_email_detail_empty: "E-mel ini tiada teks.",
  cockpit_personal_settings: "Tetapan peribadi",
  cockpit_companies: "Syarikat",
  cockpit_title: "Cockpit",
  cockpit_back: "Kembali ke ringkasan",
  cockpit_day_overview: "Hari anda sekilas pandang",
  email_saved_to_project: "E-mel disimpan ke projek",
  email_classify_need_project: "Sila masukkan nama projek",
  cockpit_email_deleted: "E-mel dipadam",
  cockpit_email_sent_empty: "Belum ada e-mel dihantar.",
  cockpit_email_incoming_empty: "Belum ada e-mel masuk.",
  cockpit_email_incoming_title: "E-mel",
  cockpit_email_incoming_sub: "Tetapkan e-mel masuk dan dihantar kepada projek anda. Anda boleh melaraskan penetapan di sini.",
  cockpit_email_incoming_unassigned_n: "{{n}} belum ditetapkan",
  cockpit_email_folder_inbox: "Peti masuk",
  cockpit_email_folder_sent: "Dihantar",
  cockpit_email_open: "Buka e-mel",
  cockpit_email_incoming_suggested: "Dicadangkan: {{room}}",
  cockpit_email_incoming_apply: "Guna",
  cockpit_email_incoming_adjust: "Laraskan penetapan",
  cockpit_email_incoming_saving: "Menyimpan …",
  cockpit_email_incoming_unassigned: "Belum ditetapkan",
  cockpit_email_incoming_show_less: "Papar lebih sedikit",
  cockpit_email_incoming_show_all: "Papar semua {{n}}",
  cockpit_io_settings: "Tetapan Kjuup.io",
  cockpit_io_settings_sub: "Pelan dan tempat duduk, penugasan pekerja, pengebilan dan invois.",
  products_coming_soon: "Akan datang",
  cockpit_upsell_io_title: "Pejabat yang turut berfikir",
  cockpit_upsell_io_text: "Sambungkan akaun e-mel anda dengan Kjuup. E-mel, lampiran dan mesej disimpan secara automatik dalam projek yang sepadan dan boleh disimpan pada pelayan anda. Setiap hari anda menerima ringkasan semua projek dengan perkara penting daripada semua kandungan, dan tugasan anda disegerakkan dengan kalendar atau aplikasi to-do anda.",
  cockpit_upsell_io_soon_title: "Belum boleh ditempah",
  cockpit_upsell_io_soon_text: "Kjuup.io akan dilancarkan tidak lama lagi. Minta maklumat sekarang – kami akan memaklumkan anda sebaik sahaja Kjuup.io boleh ditempah.",
  cockpit_upsell_io_planned_price: "Harga yang dirancang",
  cockpit_upsell_io_cta_request: "Minta maklumat",
  kjuup_plus_abo_per_year: "/ tahun",
  kjuup_plus_abo_per_month: "/ bulan",
  kjuup_plus_abo_status_active: "Aktif",
  kjuup_plus_abo_status_requested: "Pembatalan diminta",
  kjuup_plus_abo_status_past_due: "Pembayaran tertunggak",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Langganan",
  kjuup_plus_abo_title: "Pakej Kjuup+",
  kjuup_plus_abo_seats_free_one: "1 tempat duduk lagi",
  kjuup_plus_abo_billing: "Pengebilan",
  kjuup_plus_abo_yearly: "Tahunan",
  kjuup_plus_abo_monthly: "Bulanan",
  kjuup_plus_abo_amount: "Jumlah",
  kjuup_plus_abo_ends: "Tamat pada",
  kjuup_plus_abo_renews: "Pembaharuan seterusnya",
  kjuup_plus_abo_next_invoice: "Invois seterusnya",
  kjuup_plus_abo_intro: "Harga pengenalan",
  kjuup_plus_abo_pending_tier: "Bermula pembaharuan seterusnya",
  kjuup_plus_abo_manual: "Kjuup+ aktif untuk syarikat anda di bawah perjanjian individu.",
  kjuup_plus_abo_invoices: "Invois",
  kjuup_plus_abo_invoice_paid: "Dibayar",
  kjuup_plus_abo_invoice_view: "Lihat",
  kjuup_plus_abo_invoices_less: "Papar lebih sedikit",
  kjuup_plus_abo_member_hint: "Pengebilan dan pembatalan diurus oleh pentadbir syarikat anda.",
  kjuup_plus_abo_withdraw: "Tarik balik permintaan",
  kjuup_plus_abo_cancel_note: "Sebab (pilihan)",
  kjuup_plus_abo_cancel_send: "Minta pembatalan",
  kjuup_plus_abo_cancel: "Batalkan langganan",
  cockpit_upsell_plus_f1: "Urus aktiviti komunikasi semua pekerja anda",
  cockpit_upsell_plus_f2: "Maklumkan kumpulan pengguna tertentu dalam syarikat",
  cockpit_upsell_plus_f3: "Simpan sembang kumpulan dalaman",
  cockpit_upsell_plus_when_yearly: "apabila bayar tahunan",
  cockpit_upsell_plus_size_small: "1–50 pekerja",
  cockpit_upsell_plus_size_large: "51–200 pekerja",
  cockpit_upsell_plus_title: "Kjuup+ untuk syarikat",
  cockpit_upsell_plus_text: "Urus pekerja, kebenaran menulis dan komunikasi syarikat di satu tempat. Saluran dalaman kekal bersama pasukan anda, saluran luaran menghubungkan anda dengan rakan projek, dan anda boleh menghubungi kumpulan tertentu secara terus. Selain Kjuup+, anda boleh menempah akses Kjuup.io untuk kumpulan pekerja. Kjuup+ dan Kjuup.io boleh digabungkan.",
  cockpit_upsell_plus_size: "Saiz syarikat",
  cockpit_upsell_plus_billing: "Pengebilan",
  cockpit_upsell_plus_per_company: "/ syarikat · bulan tidak termasuk cukai",
  cockpit_upsell_plus_onboarding: "Kos onboarding/pengenalan bergantung pada saiz syarikat",
  cockpit_upsell_plus_larger: "Harga untuk syarikat lebih besar atas permintaan",
  cockpit_upsell_plus_cta: "Tanya tanpa komitmen",
  cockpit_kpi_deadlines_tasks: "Tarikh akhir & tugasan",
  cockpit_kpi_appointments: "Temu janji",
  cockpit_room_admin: "Pengurusan projek & sembang",
  cockpit_room_admin_sub: "Semua projek syarikat dengan ahli, media dan sembang.",
  pro_todo_not_found: "Tugasan ini tidak lagi tersedia.",
  cockpit_chip_overdue: "Lewat",
  cockpit_chip_today: "Hari ini",
  cockpit_calendar_week: "Minggu {{week}}",
  cockpit_prev_week: "Minggu sebelumnya",
  cockpit_next_week: "Minggu seterusnya",
  cockpit_chip_requested: "Diminta",
  cockpit_todo_due: "Tarikh akhir {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "daripada {{name}}",
  cockpit_todo_since: "sejak {{when}}",
  cockpit_todo_no_date: "Tiada tarikh",
  cockpit_todo_mark_done: "Tandakan selesai",
  cockpit_my_tasks_title: "Tugasan saya",
  cockpit_today_tasks_group: "Tugasan hari ini",
  cockpit_assign_none: "Tiada sesiapa ditugaskan",
  no_project_found: "Projek tidak ditemui",
  cockpit_row_more_actions: "Lagi tindakan",
  needs_date: "Tetapkan tarikh",
  cockpit_assign_proposal: "{{name}} dikenali – tetapkan?",
  cockpit_assign_proposal_confirm: "Tetapkan",
  cockpit_assign_proposal_dismiss: "Abaikan",
  cockpit_priority_date: "Tarikh",
  todo_calendar_add: "Tambah ke kalendar",
  todo_calendar_remove: "Alih keluar daripada kalendar",
  cockpit_todo_change_project: "Tukar projek",
  cockpit_todo_set_date: "Tetapkan tarikh",
  pro_todo_done_confirm: "Adakah anda pasti mahu menandakan tugasan ini sebagai selesai?",
  cockpit_task_delete_failed: "Tugasan tidak dapat dipadam.",
  cockpit_setup_title: "Selesaikan persediaan",
  cockpit_setup_text: "Tentukan sama ada anda mahu menggunakan sembang dan sama ada Kjuup.io berfungsi sebagai klien e-mel atau hanya dengan projek dan laporan harian.",
  cockpit_setup_cta: "Sediakan sekarang",
  cockpit_group_tasks: "Tarikh akhir & tugasan",
  cockpit_group_appointments: "Temu janji",
  cockpit_report_no_activity: "Projek ini tiada mesej atau e-mel baharu dalam 24 jam lepas.",
  cockpit_report_room_unavailable: "Projek ini tidak tersedia.",
  cockpit_report_create_failed: "Laporan harian tidak dapat dicipta.",
  cockpit_report_created: "Laporan harian dicipta",
  addon_enable_confirm: "Dayakan add-on?",
  addon_enable: "Dayakan",
  addon_enabled: "Add-on didayakan",
  nav_email: "E-mel",
  nav_my_cockpit: "Cockpit saya",
  nav_news: "Berita",
  nav_recommend: "Syorkan",
  pro_todo_status_done: "Selesai",
  pro_todo_status_open: "Terbuka",
  v2_todo_remove: "Alih keluar",
  pro_todo_search_people: "Cari orang",
  pro_todo_clear: "Kosongkan",
  pro_todo_assigned: "(ditugaskan)",
  pro_todo_no_people: "Tiada orang ditemui",
  pro_todo_search_rooms: "Cari projek",
  pro_todo_no_rooms_match: "Tiada projek sepadan dengan “{{q}}”",
  pro_todo_no_rooms: "Tiada projek ditemui",
  pro_todo_activity: "Aktiviti",
  pro_todo_show_less: "Papar lebih sedikit",
  pro_todo_show_all: "Papar semua ({{n}})",
  pro_todo_due: "Tarikh akhir",
  pro_todo_room: "Projek",
  pro_todo_select_room: "Pilih projek",
  pro_todo_status: "Status",
  pro_todo_more: "Lagi",
  pro_todo_edit_title: "Sunting tugasan",
  pro_todo_description: "Penerangan",
  pro_todo_created_by: "Dicipta oleh",
  pro_todo_chat: "Sembang",
  navigate_to_source: "Pergi ke sumber",
  todo_calendar_connect_title: "Tiada kalendar disambungkan",
  todo_calendar_connect_body_web: "Sambungkan kalendar dalam tetapan Segerak Kalendar untuk menambah ToDo ke dalamnya.",
  todo_calendar_connect: "Sambung",
  todo_calendar_removed: "Dialih keluar daripada kalendar anda",
  todo_calendar_added_later: "Ditambah. Kalendar anda tidak dapat dihubungi; Kjuup akan cuba lagi nanti.",
  todo_calendar_added: "Ditambah ke kalendar anda",
  todo_calendar_no_date: "Hanya ToDo yang mempunyai tarikh boleh ditambah ke kalendar.",
  todo_calendar_failed: "Kalendar anda tidak dapat dikemas kini. Sila cuba lagi.",
  todo_calendar_date_title: "Belum ada tarikh",
  todo_calendar_date_save: "Tetapkan tarikh & tambah",
  todo_calendar_date_body_web: "Tugasan yang ditanda ini belum mempunyai tarikh. Tetapkan satu untuk menambahnya ke kalendar anda.",
  kjuup_io_setup_saved: "Persediaan disimpan",
  kjuup_io_setup_step: "Langkah",
  kjuup_io_setup_chats_title: "Adakah anda mahu menggunakan sembang?",
  kjuup_io_setup_email_title: "Di mana anda mahu membaca e-mel anda?",
  kjuup_io_setup_chats_sub: "Sembang dengan rakan sekerja dan rakan projek adalah pilihan. Anda boleh memaparkan atau menyembunyikannya pada cockpit pada bila-bila masa.",
  kjuup_io_setup_email_sub: "Ini hanya memilih sama ada anda menggunakan klien e-mel dalam Kjuup atau terus menggunakan program e-mel semasa anda, seperti Outlook atau lain-lain. Anda boleh bertukar kemudian.",
  kjuup_io_setup_chats_yes: "Ya, papar sembang",
  kjuup_io_setup_chats_yes_text: "Mesej mengandungi sembang dan e-mel. Projek mempunyai sembang kumpulan untuk semua pihak yang terlibat.",
  kjuup_io_setup_chats_no: "Tidak, bekerja tanpa sembang",
  kjuup_io_setup_chats_no_text: "Sembang disembunyikan. \"Mesej\" menjadi \"E-mel\"; projek, tugasan dan laporan harian kekal.",
  kjuup_io_setup_email_client: "Klien e-mel dalam Kjuup",
  kjuup_io_setup_email_client_text: "Baca dan balas e-mel terus dalam Kjuup.",
  kjuup_io_setup_email_reports: "Klien e-mel semasa",
  kjuup_io_setup_email_reports_text: "Teruskan membaca dan membalas dalam program semasa anda, seperti Outlook atau lain-lain.",
  kjuup_io_setup_skip: "Kemudian",
  next: "Seterusnya",
  kjuup_io_setup_finish: "Selesaikan persediaan",
  today_label: "hari ini",
  tomorrow_label: "esok",
  cockpit_todo_overdue: "lewat",
  cockpit_report_management_fazit: "Ringkasan pengurusan",
  cockpit_todo_appointment: "Temu janji",
  cockpit_todo_deadline: "Tarikh akhir",
  cockpit_todo_deadline_define: "Tentukan tarikh akhir",
  pro_todo_status_acknowledged: "Disahkan",
  pro_todo_responsible: "Bertanggungjawab",
  pro_todo_notice_confirmed: "Disahkan dalam sembang",
  pro_todo_notice_sent_at: "Mesej dihantar",
  pro_todo_notice_again: "Hantar mesej sekali lagi",
  pro_todo_notice_send: "Maklumkan melalui mesej Kjuup",
  pro_todo_add_assignee: "Tambah",
  pro_todo_edit: "Sunting",
  pro_todo_change_room: "Tukar projek",
  pro_todo_due_on: "Genap tempoh pada",
  pro_todo_edit_due: "Sunting tarikh akhir",
  pro_todo_no_date: "Tiada tarikh",
  pro_todo_edit_description: "Sunting penerangan",
  pro_todo_no_description: "Belum ada penerangan",
  pro_todo_title_label: "Tajuk",
  pro_todo_title_placeholder: "Masukkan tajuk...",
  pro_todo_task: "Tugasan",
  pro_todo_what: "Apa yang perlu dilakukan?",
  pro_todo_source_email: "E-mel",
  pro_todo_sources: "Sumber",
  previous: "Sebelumnya",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (sehingga {max} pekerja)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (sehingga {max} pekerja)",
  kjuup_plus_abo_status_ends: "Tamat pada {date}",
  kjuup_plus_abo_seats_over: "Lebih daripada {max} pekerja – Kjuup akan menghubungi anda dengan tawaran khas.",
  kjuup_plus_abo_seats_next: "Jika lebih ramai pekerja menyertai, pakej akan bertukar kepada {next} secara automatik (dikira secara prorata).",
  kjuup_plus_abo_seats_used: "{used} daripada {total} tempat digunakan",
  kjuup_plus_abo_seats_free: "{count} tempat lagi",
  kjuup_plus_abo_intro_until: "sehingga {date}",
  kjuup_plus_abo_invoice_open: "Belum dibayar · perlu dibayar {date}",
  kjuup_plus_abo_invoices_all: "Tunjukkan semua {count}",
  kjuup_plus_abo_requested_hint: "Pembatalan diminta pada {date}. Kjuup mengesahkannya pada akhir tempoh ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup menyemak permintaan anda dan mengesahkan pembatalan pada akhir tempoh ({end}). Kjuup+ kekal aktif sehingga itu.",
  kjuup_plus_abo_withdrawn: "Permintaan pembatalan ditarik balik",
  kjuup_plus_abo_requested: "Pembatalan diminta",
  cockpit_upsell_plus_intro_hint: "{months} bulan pertama, kemudian {price}",
  cockpit_upsell_plus_badge: "HARGA PENGENALAN SELAMA {months} BULAN",
  calendar_syncing: "Mengemas kini daripada kalendar…",
  calendar_sync_up_to_date: "Kalendar sudah terkini",
  calendar_sync_failed: "Penyegerakan gagal",
  delete_multiple_tasks_confirm: "Adakah anda pasti mahu memadam {count} ToDo?",
  todos_deleted_count: "{count} ToDo dipadamkan",
  todos_deleted_partial: "{ok} ToDo dipadamkan, {fail} gagal",
  todo_unknown: "Tidak diketahui",
  todo_created_from_message: "Tugasan dicipta daripada mesej ini",
  kjuup_io_todo_calendar_trial_ended_note: "Penyegerakan kalendar · Langgan",
  kjuup_io_todo_calendar_nudge: "Segerakkan ToDo ini ke kalendar anda?",
  kjuup_io_todo_calendar_nudge_cta: "Aktifkan Kjuup.io",
  todo_confirmed: "ToDo disahkan",
  pro_todo_bulk_delete_title: "Padam {{n}} tugasan?",
  pro_todo_previous_none_own: "Tugasan tertunggak diberikan kepada anda oleh orang lain dan hanya boleh dipadam oleh mereka.",
  pro_todo_previous_none: "Tiada tugasan tertunggak",
  pro_todo_previous_title: "Padam {{n}} tugasan tertunggak?",
  pro_todo_previous_text: "Semua tugasan terbuka anda dari hari-hari sebelumnya akan dipadam.",
  pro_todo_previous_skipped: "{{n}} yang diberikan oleh orang lain akan kekal.",
  unassign_task_confirm: "Adakah anda mahu membatalkan tugasan anda daripada tugas ini?",
  unassign_label: "Batalkan",
  pro_todo_delete_title: "Padam tugasan",
  pro_todo_today: "Hari ini",
  pro_todo_yesterday: "Semalam",
  pro_todo_since_yesterday: "Sejak semalam",
  pro_todo_mark_open: "Tandakan sebagai terbuka",
  verify_completion: "Sahkan",
  new_label: "Baharu",
  bookmarked_no_mylist: "Tugasan yang ditanda buku tidak boleh ditambah ke Senarai Saya",
  delete_only_own: "Anda hanya boleh memadam tugasan yang anda cipta sendiri",
  todo_clear_all: "Padam semua",
  pro_todo_of_completed: "{{done}} daripada {{total}} selesai",
  pro_todo_pick_date: "Pilih tarikh",
  pro_todo_show_day: "Tunjukkan hari",
  todo_adjust_list: "Laraskan senarai",
  pro_todo_section_upcoming: "Akan datang",
  pro_todo_section_done: "Selesai",
  pro_todo_room_empty_today: "Tiada tugasan hari ini dalam projek ini",
  pro_todo_room_empty_day: "Tiada tugasan pada hari tersebut dalam projek ini",
  pro_todo_delete_previous: "Padam semua",
  todo_my_list_empty: "Hari anda kosong",
  todo_my_list_empty_hint: "Klik “Laraskan senarai” untuk menambah tugasan",
  pro_todo_empty_title: "Tiada apa-apa di sini",
  pro_todo_empty_hint: "Tiada tugasan sepadan dengan paparan ini.",
  pro_todo_selected: "{{n}} dipilih",
  delete_selected_count: "Padam ({count})",
  pro_todo_adjust_done: "Selesai",
  pro_todo_deleting: "Memadam...",
  pro_todo_reopen: "Buka semula tugasan",
  pro_todo_step_done: "Selesai",
  move_back_in_progress: "Kembalikan ke sedang berlangsung",
  pro_todo_mark_not_started: "Tandakan sebagai belum dimulakan",
  back_into_in_progress: "Kembali ke Sedang Berlangsung",
  pro_todo_mark_in_progress: "Tandakan sebagai sedang dijalankan",
  unassign_todo: "Batalkan tugasan ToDo",
  pro_todo_open_room: "Buka projek",
  pro_todo_new_task: "Tugasan baru",
  select_user_back_to_in_progress: "Pilih pengguna untuk dikembalikan ke sedang berlangsung",
  cockpit_email_accounts_n_many: "{{n}} akaun disambungkan",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kenalan Kjuup",
  combined_tab_teams: "Kenalan Teams",
  combined_bridge_failed: "Salinan Teams tidak dapat dibuat.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kenalan Kjuup dan Teams: kumpulan baharu dicipta yang turut muncul dalam Microsoft Teams.",
  teams_new_chat_title: "Sembang Teams baharu",
  teams_new_chat_topic: "Nama kumpulan (pilihan)",
  teams_new_chat_start: "Mulakan sembang",
  teams_new_chat_creating: "Mencipta sembang…",
  teams_new_chat_forbidden: "Microsoft Teams tidak membenarkan sembang ini (cth. orang di luar organisasi anda atau dasar IT anda).",
  teams_new_chat_too_many: "Terlalu ramai orang untuk satu sembang.",
  teams_new_chat_type_hint: "Taip nama untuk mencari dalam organisasi anda.",
  teams_new_chat_directory_forbidden: "Organisasi anda tidak membenarkan carian direktori. Hanya orang daripada sembang Teams anda dipaparkan.",
  teams_new_chat_account: "Akaun",
};
